export default "/_next/static/chunks/fonts/RobotoMono-Regular-d15ae7dd2d4e47ee9ed309267b1dd15c.woff";